import { render, staticRenderFns } from "./newDemo.vue?vue&type=template&id=1660d3bd&scoped=true"
import script from "./newDemo.vue?vue&type=script&lang=js"
export * from "./newDemo.vue?vue&type=script&lang=js"
import style0 from "./newDemo.vue?vue&type=style&index=0&id=1660d3bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1660d3bd",
  null
  
)

export default component.exports